export default {
  authData: 'auth-data',
  language: 'language',
  reportDirectoryUri: 'report-directory-uri',
  currentVenue: 'current-venue',
  notProcessedOrders: 'not-processed-orders',
  storedProducts: 'stored-products',
};
